type Props = {
  count: number | null;
};

export const OverdueCell = ({ count }: Props) => {
  if (count === null) {
    return <span aria-hidden="true" className="inline-block h-3 w-8 rounded bg-quaternary/30 animate-pulse" />;
  }
  if (count <= 0) {
    return <span className="text-xs text-primary font-medium">0</span>;
  }
  return <span className="text-xs font-medium text-warning-600 whitespace-nowrap">{count}</span>;
};
